<template>
  <div class="tw:relative">
    <SearchResults
      :data="!isSearchSuggestionsFetching ? searchSuggestions : []"
      :suggestions="suggestions"
      :searchInput="searchValue"
      :searchValue="searchValue"
      :selectedValues="selectedValues"
      :isOpen="openResults"
      :isSearching="isLoading"
      :on-clickaway="hideResults"
      @onSelect="option => onSelect(option)"
      @onInput="event => setSearchValue(event)"
      @onFocus="showResultsOnFocus"
      @onBlur="isInputFocused = false"
    />
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'

import SearchResults from '@/components/rateInsights/onboarding/SearchResults.vue'
import apis from '@/services'

import { useSessionValues } from '@/composables/useSessionValues'
import { debounce } from '@/utils/Utility'

const props = defineProps({
  suggestions: Array,
  selectedValues: Array,
})

const { language } = useSessionValues()
const searchValue = ref('')
const openResults = ref(false)
const isInputFocused = ref(false)
const searchSuggestions = ref([])
const isLoading = ref(false)
const emit = defineEmits(['onSelect'])
const onSelect = value => {
  emit('onSelect', value)
}

watch(
  () => props.selectedValues,
  newSelectedValues => {
    if (newSelectedValues.length === 5) {
      hideResults()
    }
  }
)
const setSearchValue = event => {
  isLoading.value = true
  searchValue.value = event.target.value
}

const hideResults = () => {
  if (!isInputFocused.value) {
    openResults.value = false
    searchValue.value = ''
  }
}

const showResultsOnFocus = () => {
  isInputFocused.value = true
  if (
    searchValue.value.length > 0 ||
    props.suggestions ||
    (searchSuggestions.value && searchSuggestions?.value !== null && searchSuggestions?.value?.length > 0)
  ) {
    openResults.value = true
  }
}

const fetchSearchSuggestions = async searchValue => {
  if (searchValue.length <= 2) return
  await apis.accommodation.newSearch({ searchTerm: searchValue, language: language.value })
    .then(result => {
      isLoading.value = false
      searchSuggestions.value = result.data
    })
    .catch(() => {
      isLoading.value = false
      searchSuggestions.value = []
    })
}

const debounceSearchValue = debounce(fetchSearchSuggestions, 500)
watch(searchValue, debounceSearchValue)

watch(
  searchSuggestions,
  newValue => {
    if (newValue?.length > 0) {
      openResults.value = true
    }
  },
  { immediate: true }
)
</script>
